import React from 'react';

import { PrivatePage } from '../../components/private-page';
import { ctGameDefault, ctGameTitle } from '../../constants/text';
import { ZoneLibraryGrid } from '../../features/zone-library-grid';

export const ZoneLibraries = () => {
  React.useEffect(() => {
    document.title = ctGameTitle + ' - My Library';
    return () => {
      document.title = ctGameDefault;
    };
  }, []);

  return (
    <PrivatePage
      className={'page-base--full'}
      breadcrumb={[
        { label: 'Dashboard', href: '../dashboard' },
        { label: 'My Library', href: '../mylibrary/zones' },
        { label: 'Zone Maps', href: '../mylibrary/zones' }
      ]}
      pageTitle={'My Library'}>
      <ZoneLibraryGrid />
    </PrivatePage>
  );
};
